import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  Paper as MuiPaper,
  Typography,
  Button,
  Stack,
  Paper,
  Dialog,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import EditModal from "../../Modal";
import { styled } from "@mui/system";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import BouncingDotsLoader from "../../../../../../components/Loaders/smallBounceLoader";
import CardHeader from "../CardHeader";
import NotFound from "../../../../../../components/NotFound/NotFound";
import Tags from "./Components/Tags";
import ServicesTags from "./Components/ServicesTags";
import BrandTags from "./Components/BrandTags";
const useStyles = makeStyles((theme) => ({
  titleName: {
    fontWeight: "700",
    fontSize: "20px",
    color: "#1B2430",
  },
  headName: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#1B2430",
  },
  headNameDesc: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#06BDFF",
    display: "column",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tagsText: {
    fontSize: "14px",
    fontWeight: "400",
    padding: "2px",
  },
  tagsItem: {
    background: "#EBEBEC",
    minWidth: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: "700px",
    flexWrap: "nowrap",
  },
}));
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    placement="top-start"
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#1B2430",
    borderRadius: "8px",
  },
}));
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
function Companylabel({
  locationDetailsData,
  location,
  getLocationDetails,
  setLocationDetailsData,
  locationCategory,
  getLocationDetailsListing,
  lodgingCategories,
  categoryLoading,
  addPermission,
  editPermission,
  deletePermission,
  viewPermission,
  centerData,
  displayMapError,
}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();
  const [openDefaultModel, setOpenDefaultModel] = useState(false);

  const handleOpenTemplateMenu = () => {
    setOpenDefaultModel(true);
  };
  const handleCloseTemplateMenu = () => {
    setOpenDefaultModel(false);
  };

  return (
    <>
      {openDefaultModel && (
        <EditModal
          open={openDefaultModel}
          modalIndex={10}
          location={location}
          getLocationDetails={getLocationDetails}
          locationDetailsData={locationDetailsData}
          onCancel={handleCloseTemplateMenu}
          locationCategory={locationCategory}
          setLocationDetailsData={setLocationDetailsData}
          getLocationDetailsListing={getLocationDetailsListing}
          lodgingCategories={lodgingCategories}
          categoryLoading={categoryLoading}
          centerData={centerData}
          displayMapError={displayMapError}
        />
      )}
      <Card variant="outlined" className={classes.listingCard}>
        {isLoading ? (
          <BouncingDotsLoader />
        ) : (
          <>
            {locationDetailsData !== null ? (
              <Grid container spacing={1}>
                <CardHeader
                  title={t("Services_&_Brands")}
                  editPermission={editPermission}
                  viewPermission={viewPermission}
                  handleOpenTemplateMenu={handleOpenTemplateMenu}
                />
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {/*   <Grid
                    container
                    sx={{
                      paddingX: "16px",
                      paddingY: "8px",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={5}
                      md={5}
                      lg={5}
                      sx={{ alignItems: "center" }}
                    >
                      <Typography className={classes.headName}>
                        {t("Labels")}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={7}
                      md={7}
                      lg={7}
                      sx={{ width: "40px" }}
                    >
                      <Tags locationDetailsData={locationDetailsData} />
                    </Grid>
                  </Grid> */}
                  <Grid
                    container
                    sx={{
                      paddingX: "16px",
                      paddingY: "8px",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={5}
                      md={5}
                      lg={5}
                      sx={{ alignItems: "center" }}
                    >
                      <Typography className={classes.headName}>
                        {t("brands")}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={7}
                      md={7}
                      lg={7}
                      sx={{ width: "40px" }}
                    >
                      <BrandTags locationDetailsData={locationDetailsData} />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={{
                      paddingX: "16px",
                      paddingY: "8px",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={5}
                      md={5}
                      lg={5}
                      sx={{ alignItems: "center" }}
                    >
                      <Typography className={classes.headName}>
                        {t("Services")}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={7}
                      md={7}
                      lg={7}
                      sx={{ width: "40px" }}
                    >
                      <ServicesTags locationDetailsData={locationDetailsData} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <NotFound text={t("No_Data_Found")} />
            )}
          </>
        )}
      </Card>
    </>
  );
}
export default Companylabel;
